import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'canvas-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  standalone: true
})
export class SlideToggleComponent {
  @Input() isToggled = false;
  @Input() disabled = false;

  @Output() toggleChange = new EventEmitter<boolean>();

  toggle(): void {
    if (this.disabled) return;

    this.isToggled = !this.isToggled;
    this.toggleChange.emit(this.isToggled);
  }
}